import FeaturedSolutions from "../../../components/FeaturedSolutions";
import HorizontalLine from "../../../components/icons/HorizontalLine";
import LogoMini from "../../../components/icons/LogoMini";
import InfoGenesis from "../../../assets/img/Featured/tablet-info-genesis.png";
import IGOnDemand from "../../../assets/img/Featured/app-ondemand-food.png";
import IGKiosk from "../../../assets/img/Featured/kiosk-food-order-tall.png";
import DigitalMenu from "../../../assets/img/Featured/digital-menu.png";
import Analyze from "../../../assets/img/Featured/app-analyze.png";
import "./index.scss";
import { useNavigate } from "react-router-dom";
import { useAnalytics } from "@popped/popshap-kiosk-components";
import { useCallback } from "react";
import { useData } from "../../../context/DataProvider";
import { Header } from "../../../components/Header";

const FoodHallPage = () => {
    const { logEvent } = useAnalytics();
    const { addFlow, location } = useData()!;
    const _logEvent = useCallback(async (type: string, value: string, id?: string) => {
        await logEvent(type, value, { kiosk: location, id: id })
    }, [logEvent,location])
    const navigate = useNavigate();
    return (
      <div className="page foodHallPage">
        <Header />
        <div className="page-header">Business & Industry Dining</div>
        <div className="text-wrapper">
          <div className="top">
            <div className="topic-header">Food Hall</div>
            <HorizontalLine />
          </div>
          <div className="std-text">
            Deliver personalized, speed-appropriate service with real-time
            insights into dietary needs, preferences, and allergen alerts.
            Support rotating menus and grab-and-go options with mobile scanning
            and self-checkout.{"\n\n"}
            Behind the scenes, customizable dashboards and granular KPIs reveal
            behavior patterns, optimize inventory, and improve profitability,
            building the foundation for experience-driven dining excellence in
            today's evolving corporate dining environments.
          </div>
        </div>

        <FeaturedSolutions>
          <div
            className="featured-item"
            onClick={() => {
              _logEvent(
                "click",
                "Business & Industry Dining - Food Hall",
                "InfoGenesis"
              );
              addFlow("InfoGenesis");
              navigate("/solutions/info-genesis");
            }}
          >
            <div className="item-head">
              <LogoMini />
              InfoGenesis
            </div>
            <img src={InfoGenesis} alt="" />
          </div>
          <div
            className="featured-item"
            onClick={() => {
              _logEvent(
                "click",
                "Business & Industry Dining - Food Hall",
                "IG OnDemand"
              );
              addFlow("IG OnDemand");
              navigate("/solutions/ig-on-demand");
            }}
          >
            <div className="item-head">
              <LogoMini />
              IG OnDemand
            </div>
            <img src={IGOnDemand} alt="" />
          </div>
          <div
            className="featured-item"
            onClick={() => {
              _logEvent(
                "click",
                "Business & Industry Dining - Food Hall",
                "IG Kiosk"
              );
              addFlow("IG Kiosk");
              navigate("/solutions/ig-kiosk");
            }}
          >
            <div className="item-head">
              <LogoMini />
              IG Kiosk
            </div>
            <img src={IGKiosk} alt="" />
          </div>
          <div
            className="featured-item"
            onClick={() => {
              _logEvent(
                "click",
                "Business & Industry Dining - Food Hall",
                "IG Digital Menu Board"
              );
              addFlow("IG Digital Menu Board");
              navigate("/solutions/digital-menu");
            }}
          >
            <div className="item-head">
              <LogoMini />
              IG Digital Menu Board
            </div>
            <img src={DigitalMenu} alt="" />
          </div>
          <div
            className="featured-item"
            onClick={() => {
              _logEvent(
                "click",
                "Business & Industry Dining - Food Hall",
                "Analyze"
              );
              addFlow("Analyze");
              navigate("/solutions/analyze");
            }}
          >
            <div className="item-head">
              <LogoMini />
              Analyze
            </div>
            <img src={Analyze} alt="" />
          </div>
        </FeaturedSolutions>
      </div>
    );
}
export default FoodHallPage;